import { buildModuleApi } from '../../../../../_CORE/API/_ApiUtil/_buildModuleApi';

const STANDARD = [
    'LIST', 'CREATE', 'UPDATE', 'REMOVE', 'DETAIL', 'ARCHIVE', 'RESTORE', 'ARCHIVED',
    'BULK_CREATE', 'BULK_ARCHIVE', 'BULK_RESTORE', 'BULK_REMOVE_REQUEST', 'BULK_REMOVE_CONFIRM',
];

const { API, CONSTANTS, ENDPOINTS } = buildModuleApi({
    prefix: 'PORTFOLIO_PUBLIC',
    uri: 'portfolio',
    exclude: STANDARD,
    withExtra: false,
    extraActions: {
        GET: { suffix: '' },
    },
});

export const PORTFOLIO_PUBLIC_API = API;
export const PORTFOLIO_PUBLIC_CONSTANTS = CONSTANTS;
export const PORTFOLIO_PUBLIC_ENDPOINTS = ENDPOINTS;
